// extracted by css-extract-rspack-plugin
export default {"noDataState":"noDataState-gOBaRz","headerSwitchers":"headerSwitchers-XqsTNx","chartFrame":"chartFrame-_qahwF","plotArea":"plotArea-rtHmf0","chartBody":"chartBody-LNMgSs"};